import {MOBILE_QUERY} from '@pinecast/common/hooks/useIsMobile';

/**
 * On a phone, a transcript that is being read puts each speaker's name on its
 * own line, above their words, instead of in a column beside them. The words
 * then get the full width of the screen.
 *
 * It is the phone breakpoint of the app, so the transcript changes its layout
 * together with the page around it. Styletron reads only `@media` rules, so
 * this is the width of the viewport, not of the transcript.
 */
export const NARROW = `@media ${MOBILE_QUERY}`;
